/* class decorator */
export function staticImplementsDecorator<T>() {
  return <U extends T>(constructor: U) => {
    constructor;
  };
}
